import { APIPath } from '../constants/api';
import { BaseService } from './base';

class FpPartners {
  getWMSwarehouses = () => BaseService.get(APIPath.fpPartnersWarehouses);

  integrateWMSwarehouse = data =>
    BaseService.post(APIPath.fpPartnersWarehousesInterate, data);
}

const FpPartnersService = new FpPartners();
Object.freeze(FpPartnersService);
export default FpPartnersService;
